var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1739175463812,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2222,
    width: 48,
    height: 48,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M788.48 1024H235.52C176 1024 128 976 128 916.48V107.52C128 48 176 0 235.52 0h552.96C848 0 896 48 896 107.52v808.96c0 59.52-48 107.52-107.52 107.52zM235.52 64C211.2 64 192 83.2 192 107.52v808.96c0 24.32 19.2 43.52 43.52 43.52h552.96c24.32 0 43.52-19.2 43.52-43.52V107.52c0-24.32-19.2-43.52-43.52-43.52H235.52z",
    fill: "#5f7fe9",
    "p-id": 2223
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M544 832H471.68c-17.92 0-32-14.08-32-32s14.08-32 32-32H544c17.92 0 32 14.08 32 32s-14.08 32-32 32z",
    fill: "#5f7fe9",
    "p-id": 2224
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/手机.baa6ab33bc3810fef46afd60715af743.svg";
export { ForwardRef as ReactComponent };